var render = function render(){var _vm=this,_c=_vm._self._c;return _c('energy-panel',{staticClass:"is-drillable",attrs:{"title":"分项能耗结构"},nativeOn:{"click":function($event){return _vm.handleDrilldown.apply(null, arguments)}}},[_c('e-chart-host',{ref:"chart",attrs:{"option":_vm.option,"aria-label":"近7日租户与公区能耗环形图"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }